export default __webpack_public_path__ + "static/media/MaskGroup247.8e89f2ed.png";